import { render, staticRenderFns } from "./CompanyFormRooof.vue?vue&type=template&id=1685b66c&scoped=true&"
import script from "./CompanyFormRooof.vue?vue&type=script&lang=js&"
export * from "./CompanyFormRooof.vue?vue&type=script&lang=js&"
import style0 from "./CompanyFormRooof.vue?vue&type=style&index=0&id=1685b66c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1685b66c",
  null
  
)

export default component.exports